<template>
  <v-dialog fullscreen v-model="dialog">
    <v-toolbar dark color="secondary">
      <v-btn icon dark @click="handleClose">
        <v-icon>mdi-close</v-icon>
      </v-btn>
      <v-toolbar-title>Migration summary</v-toolbar-title>
    </v-toolbar>
    <v-toolbar>
      <v-tabs grow v-model="tabs">
        <v-tab :key="tab.title" v-for="tab in SummaryTabsList">
          {{ tab.title }}

          <v-tooltip bottom v-if="tab.description">
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                dark
                class="ml-2"
                color="secondary"
                v-bind="attrs"
                v-on="on"
              >
                mdi-help-circle-outline
              </v-icon>
            </template>
            <span>
              {{ tab.description }}
            </span>
          </v-tooltip>
        </v-tab>
      </v-tabs>
    </v-toolbar>
    <v-card color="summary-wrapper">
      <v-tabs-items v-model="tabs">
        <v-tab-item :key="tab.title" v-for="tab in SummaryTabsList">
          <v-card>
            <MigrationSummaryItems
              :columns="tab.columns"
              :title="tab.title"
              :filter="tab.filterParams"
            />
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </v-dialog>
</template>

<script>
import MigrationSummaryItems from '@/components/dialogs/MigrationSummary/MigrationSummaryItems';
import { CategoriesMap, RowStatusesNamesMap } from '@/constants';

const CommonColumnsList = [
  {
    text: 'Original name',
    value: 'orig_name'
  },
  {
    text: 'Rhapsody name',
    value: 'rhapsody_name'
  },
  {
    text: 'Price',
    value: 'priceInfo.price'
  },
  {
    text: 'Minimum price',
    value: 'priceInfo.minimum_price',
    width: 100
  }
];

const SummaryTabsList = [
  {
    title: 'Importing',
    description: 'Items, that we are going to import',
    filterParams: {
      categories: [
        CategoriesMap.DRUG,
        CategoriesMap.PROCEDURE,
        CategoriesMap.SUPPLY,
        CategoriesMap.FOOD,
        CategoriesMap.LAB,
        CategoriesMap.VACCINE
      ]
    },
    columns: CommonColumnsList
  },
  {
    title: 'Not importing',
    description: 'Items, that we do not import',
    filterParams: {
      categories: [CategoriesMap.IGNORE, CategoriesMap.UNMATCHED]
    },
    columns: [
      {
        text: 'Original name',
        value: 'orig_name'
      },
      {
        text: 'Rhapsody name',
        value: 'rhapsody_name'
      },
      {
        text: 'Price',
        value: 'priceInfo.price'
      },
      {
        text: 'Last sold',
        value: 'priceInfo.lastsold'
      },
      {
        text: 'Reason',
        value: 'comment'
      }
    ]
  },
  {
    title: 'Imported',
    description: 'Items, that have been already imported',
    filterParams: {
      statusesNames: [RowStatusesNamesMap.IMPORTED]
    },
    columns: CommonColumnsList
  }
];

export default {
  data() {
    return {
      SummaryTabsList,
      dialog: false,
      tabs: 0
    };
  },
  components: {
    MigrationSummaryItems
  },
  methods: {
    open() {
      this.dialog = true;
    },
    handleClose() {
      this.dialog = false;
    }
  }
};
</script>
